import Vue from 'vue'
import Router from 'vue-router'
import imServer from '@/components/imServer/imServer'
import imClient from '@/components/imClient/imClient'
import imTinggo from '@/components/imTinggo/imTinggo'
import image from '@/components/imClient/image.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        { path: '/', redirect: 'imClient' },
        { path: '/imServer', name: 'imServer', component: imServer },
        { path: '/imClient', name: 'imClient', component: imClient },
        { path: '/imTinggo', name: 'imTinggo', component: imTinggo },
        { path: '/image', name: 'image', component: image },
    ]
})